﻿export class UploadResult {
    static $type = 'Web.UploadResult';

    fileId: string;
    fileName: string;
    length: number;
}